<template>
  <div class="content w-1920">
    <Header />
    <Search />
    <div class="breadcrumb w-1200">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: 'user-centered' }"
          >{{ $t('floatNav.Account') }}</el-breadcrumb-item
        >
        <el-breadcrumb-item>{{ $t('left_menu.Order_Center') }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ $t('label.Order_number') }}:{{ list.orderNo }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="status w-1200">
      <!-- <div class="status_L">
        <div class="dingdan">订单中心：12663844968550</div>
        <div class="sucess">{{ $t('common.Complete') }}</div>
        <div class="fapiao">查看发票详情</div>
        <div class="dayin">
          <img src="../../assets/order/dayin.png" alt="" />
          <span>打印订单</span>
        </div>
      </div> -->
      <div class="jieshao">
        <div class="jie_L">
          <Uimage :src="list.orderSkuVoList[0].url" alt="" />
        </div>
        <div class="jie_R">
          <div>{{ $t('message.shortmessage-050') }}</div>
          <div>{{ $t('message.shortmessage-051') }}<span>{{ $t('message.Express_consultation') }}</span></div>
          <div>{{ $t('message.shortmessage-052') }}：{{ list.expressNum }}</div>
        </div>
      </div>
      <div class="status_R">
        <div class="shang">
          {{ $t('message.shortmessage-053') }}
        </div>
        <div class="zhong">
          <div class="dingdan">
            <img
              v-if="list.orderStatus == 0"
              src="../../assets/order/dingdan1.png"
              alt=""
            />
            <img v-else src="../../assets/order/dingdan.png" alt="" />
            <div class="zt">{{ $t('button.Submit_an_order') }}</div>
            <div class="time">{{ list.orderTime }}</div>
          </div>
          <div class="jiantou">
            <img src="../../assets/order/jiantou.png" alt="" />
          </div>
          <div class="fukuan">
            <img
              v-if="list.orderStatus == 1"
              src="../../assets/order/fukuan1.png"
              alt=""
            />
            <img v-else src="../../assets/order/fukuan.png" alt="" />
            <div class="zt">{{ $t('message.Payment_successful') }}</div>
            <div class="time">{{ list.payTime }}</div>
          </div>
          <div class="jiantou">
            <img src="../../assets/order/jiantou.png" alt="" />
          </div>
          <div class="shangpin">
            <img
              v-if="list.orderStatus == 2"
              src="../../assets/order/shangpin1.png"
              alt=""
            />
            <img v-else src="../../assets/order/shangpin.png" alt="" />
            <div class="zt">{{ $t('message.Commodity_delivery') }}</div>
            <div class="time">{{ list.deliveryTime }}</div>
          </div>
          <div class="jiantou">
            <img src="../../assets/order/jiantou.png" alt="" />
          </div>
          <div class="shouhuo">
            <img
              v-if="list.orderStatus == 3"
              src="../../assets/order/shouhuo1.png"
              alt=""
            />
            <img v-else src="../../assets/order/shouhuo.png" alt="" />
            <div class="zt">{{ $t('button.Confirm_receipt_of_goods') }}</div>
            <div class="time">{{ list.receiveTime }}</div>
          </div>
          <div class="jiantou">
            <img src="../../assets/order/jiantou.png" alt="" />
          </div>
          <div class="wancheng">
            <img
              v-if="list.orderStatus == 4"
              src="../../assets/order/wancheng1.png"
              alt=""
            />
            <img v-else src="../../assets/order/wancheng.png" alt="" />
            <div class="zt">{{ $t('common.Complete') }}</div>
            <div class="time">{{ list.finishTime }}</div>
          </div>
        </div>
        <div class="xia">
          <!--          <img src="../../assets/order/jifen.png" alt="" />-->
          <!--          <span>积分</span>-->
          <!--          <span class="num">+0</span>-->
        </div>
      </div>
    </div>
    <div class="shouhuo_detail w-1200">
      <div class="xinxi">
        <span class="spen">{{ $t('common.Consignee_information') }}</span>
        <div class="xinxi1">
          <div class="xinxi1_L">{{ $t('label.Consignee') }}：</div>
          <div class="xinxi1_R">{{ list.customerName }}</div>
        </div>
        <div class="xinxi1">
          <div class="xinxi1_L">{{ $t('label.Address') }}：</div>
          <div class="xinxi1_R">
            {{ list.customerAddress }}
          </div>
        </div>
        <div class="xinxi1">
          <div class="xinxi1_L">{{ $t('label.Mobile_phone_number') }}：</div>
          <div class="xinxi1_R">
            {{ list.customerPhone }}
          </div>
        </div>
        <div class="xinxi1">
          <div class="xinxi1_L">{{ $t('label.Delivery_method') }}：</div>
          <div class="xinxi1_R">{{ list.deliveryMethod }}</div>
        </div>
        <div class="xinxi1">
          <div class="xinxi1_L">{{ $t('label.Buyers_note') }}：</div>
          <div class="xinxi1_R">
            {{ list.buyerRemark }}
          </div>
        </div>
      </div>
      <!-- <div class="peisong">
        <span class="spen">配送信息</span>
        <div class="xinxi1">
          <div class="xinxi1_L">配送方式：</div>
          <div class="xinxi1_R">标物快递</div>
        </div>
        <div class="xinxi1">
          <div class="xinxi1_L">期望送货日期：</div>
          <div class="xinxi1_R">
            2020-7-14
          </div>
        </div>
        <div class="xinxi1">
          <div class="xinxi1_L">期望配送时间：</div>
          <div class="xinxi1_R">
            9:00-15:00
          </div>
        </div>
      </div> -->
      <div class="fukuan">
        <span class="spen">{{ $t('label.Payment_information') }}</span>
        <div class="xinxi1">
          <div class="xinxi1_L">{{ $t('label.Payment_status') }}：</div>
          <div class="xinxi1_R" v-if="list.orderStatus == 0">{{ $t('common.due') }}</div>
          <div
            class="xinxi1_R"
            v-else-if="
              list.orderStatus == 5 ||
                list.orderStatus == 6 ||
                list.orderStatus == 7 ||
                list.orderStatus == 10 ||
                list.orderStatus == 20
            "
          >
            --
          </div>
          <div class="xinxi1_R" v-else>{{ $t('label.paid') }}</div>
        </div>
        <div class="xinxi1">
          <div class="xinxi1_L">{{ $t('label.Payment_method') }}：</div>
          <div class="xinxi1_R" v-if="list.orderSource == 4">{{ $t('button.Point_exchange') }}</div>
          <div
            class="xinxi1_R"
            v-else-if="
              list.orderStatus == 5 ||
                list.orderStatus == 6 ||
                list.orderStatus == 7 ||
                list.orderStatus == 10 ||
                list.orderStatus == 20
            "
          >
            --
          </div>
          <div class="xinxi1_R" v-else>{{ $t('button.Online_payment') }}</div>
        </div>
        <div class="xinxi1">
          <div class="xinxi1_L">{{ $t('label.Time_of_payment') }}：</div>
          <div
            class="xinxi1_R"
            v-if="
              list.orderStatus == 5 ||
                list.orderStatus == 6 ||
                list.orderStatus == 7 ||
                list.orderStatus == 10 ||
                list.orderStatus == 20
            "
          >
            --
          </div>
          <div class="xinxi1_R" v-else>
            {{ list.payTime }}
          </div>
        </div>
      </div>
    </div>

    <div class="fahuo_detail w-1200" v-if="msg!=null">
      <div class="xinxi">
        <span class="spen">{{ $t('label.Contract_info') }}</span>
        <div class="xinxi1" v-if="erpContractMsg!=''">
          <div class="xinxi1_L">{{ $t('label.Contract_number') }}：</div>
          <div class="xinxi1_R">{{ erpContract.contractCode }}</div>
        </div>
        <div class="xinxi1" v-else>
          <div class="xinxi1_L">{{$t('label.No_contract_data_available')}}</div>
        </div>
        <span class="spen">{{ $t('label.Filled_condition') }}</span>
        <el-table v-if="msg == '充装任务'" :data="FillingList" border width="1145px">
          <el-table-column prop="certificateNo" :label="$t('common.Mark_number')" width="240px">
          </el-table-column>
          <el-table-column prop="ProductName" :label="$t('label.standard_material_name')" width="280px">
          </el-table-column>
          <el-table-column prop="cylinderNumber" :label="$t('label.Cylinder_number')" width="200px">
          </el-table-column>
          <el-table-column prop="TaskCompletionTime" :label="$t('label.Filling_completion_time')" width="240px" :formatter="formatDate">
          </el-table-column>
          <el-table-column prop="fillingStatus" :label="$t('label.Filled_condition')" width="160px">
            <template slot-scope="scope">
              <span v-if="scope.row.Consignor !=null && scope.row.Consignor != ''">{{ $t('label.shipped') }}</span>
              <span v-if="scope.row.Consignor ==null || scope.row.Consignor == ''">
                <span v-if="scope.row.fillingStatus == '1'">{{ $t('label.To_be_calculated') }}</span>
                <span v-if="scope.row.fillingStatus == '2'">{{ $t('label.To_be_assigned') }}</span>
                <span v-if="scope.row.fillingStatus == '3'">{{ $t('label.To_be_filled') }}</span>
                <span v-if="scope.row.fillingStatus == '4'">{{ $t('label.Be_filling') }}</span>
                <span v-if="scope.row.fillingStatus == '5'">{{ $t('label.Closed') }}</span>
                <span v-if="scope.row.fillingStatus == '6'"><span v-if="scope.row.InspectionStatus == null||scope.row.InspectionStatus==''">{{ $t('label.In_quality_inspection') }}</span><span v-if="scope.row.InspectionStatus == '6'">{{ $t('label.Completion_of_quality_inspection') }}</span></span>
                <span v-if="scope.row.fillingStatus == '7'">{{ $t('label.Artificial_termination') }}</span>
                <span v-if="scope.row.fillingStatus == '8'">{{ $t('label.Partial_assignment') }}</span>
                <span v-if="scope.row.fillingStatus == '9'">{{ $t('label.Partial_filling') }}</span>
                <span v-if="scope.row.fillingStatus == '10'">{{ $t('label.Cylinder_pretreatment') }}</span>
                <span v-if="scope.row.fillingStatus == '11'">{{ $t('label.Gas_cylinder_pretreatment') }}</span>
                <span v-if="scope.row.fillingStatus == '12'">{{ $t('label.Gas_cylinder_pretreatment') }}</span>
                <span v-if="scope.row.fillingStatus == '13'">{{ $t('label.Reassign') }}</span>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-table v-if="msg == '未充装'" :data="FillingList2" border width="1145px" :empty-text="Remark">
          <el-table-column prop="certificateNo" :label="$t('common.Mark_number')" width="240px">
          </el-table-column>
          <el-table-column prop="gasName" :label="$t('label.standard_material_name')" width="280px">
          </el-table-column>
          <el-table-column prop="cylinderNumber" :label="$t('label.Cylinder_number')" width="200px">
          </el-table-column>
          <el-table-column prop="TaskCompletionTime" :label="$t('label.Filling_completion_time')" width="240px" :formatter="formatDate">
          </el-table-column>
          <el-table-column prop="fillingStatus" :label="$t('label.Filled_condition')" width="160px">
          </el-table-column>
        </el-table>
        <el-table v-if="msg == '未审核至ERP'" :data="FillingList2" border width="1145px" :empty-text="$t('label.Not_audited_to_ERP')">
          <el-table-column prop="certificateNo" :label="$t('common.Mark_number')" width="240px">
          </el-table-column>
          <el-table-column prop="gasName" :label="$t('label.standard_material_name')" width="280px">
          </el-table-column>
          <el-table-column prop="cylinderNumber" :label="$t('label.Cylinder_number')" width="200px">
          </el-table-column>
          <el-table-column prop="TaskCompletionTime" :label="$t('label.Filling_completion_time')" width="240px" :formatter="formatDate">
          </el-table-column>
          <el-table-column prop="fillingStatus" :label="$t('label.Filled_condition')" width="160px">
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="fahuo_detail w-1200" v-if="cylinderList != null && cylinderList.length > 0">
      <div class="xinxi">
        <span class="spen">{{ $t('label.Shipping_information') }}</span>
        <el-table :data="cylinderList" border width="1145px">
          <el-table-column prop="certificateNo" :label="$t('common.Mark_number')" width="280px">
          </el-table-column>
          <el-table-column prop="gasName" :label="$t('label.standard_material_name')" width="280px">
          </el-table-column>
          <el-table-column prop="cylinderCode" :label="$t('label.Cylinder_number')" width="280px">
          </el-table-column>
          <el-table-column prop="createTime" :label="$t('label.Delivery_time')" width="280px">
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="biaoge w-1200">
      <el-table :data="tableData" border width="100%">
        <el-table-column :label="$t('label.Product_picture')" width="200px">
          <template slot-scope="scope">
            <Uimage :src="scope.row.url" style="height: 130px;width: 150px" />
          </template>
        </el-table-column>
        <el-table-column prop="spuName" :label="$t('label.Commodity_attribute')">
          <template slot-scope="scope">
            <div class="title" style="color: #333;height: 20px;">
              {{ scope.row.spuName }}
            </div>
            <div
              class="zufen"
              v-for="(item, index) in scope.row.contentValue"
              :key="index"
            >
              <div class="xinghao">{{ item.attrName }}：</div>
              <div class="xinghao" v-html="item.attrValue"></div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="skuNum" :label="$t('common.Mark_number')" width="150px">
        </el-table-column>
        <el-table-column v-if="list.orderSource != 4" prop="skuPrice" :label="$t('label.Standard_material_price') +'（￥）'" width="150px">
        </el-table-column>
        <el-table-column prop="skuCount" :label="$t('label.Commodity_quantity')" width="100px">
        </el-table-column>
        <el-table-column prop="buyerNote" :label="$t('label.Product_remarks')" width="100px">
        </el-table-column>
      </el-table>
      <div v-if="list.orderSource == 4">
        <div class="zonghe">
          <div class="zonghe_L">{{ $t('label.Total_score') }}:</div>
          <div class="zonghe_R">
            {{ list.useScore }}
          </div>
        </div>
        <div class="zonghe">
          <div class="zonghe_L red">{{ $t('label.Paid_integral') }}:</div>
          <div class="zonghe_R red1">
            {{ list.useScore }}
          </div>
        </div>
      </div>
      <div v-else>
        <div class="zonghe">
          <div class="zonghe_L">{{ $t('label.Original_cost_of_goods') }}:</div>
          <div class="zonghe_R">
            {{$t('currency.symbol')}}{{ Number(list.orderTotalAmount - list.orderFreight).toFixed(2) }}
          </div>
        </div>
        <div class="zonghe">
          <div class="zonghe_L">{{ $t('label.freight') }}:</div>
          <div class="zonghe_R">
            +{{$t('currency.symbol')}}{{ Number(list.orderFreight).toFixed(2) }}
          </div>
        </div>
        <div class="zonghe">
          <div class="zonghe_L">{{ $t('label.Discount_amount') }}:</div>
          <div class="zonghe_R">
            -{{$t('currency.symbol')}}{{ Number(list.sellerDiscount).toFixed(2) }}
          </div>
        </div>
        <div class="zonghe">
          <div class="zonghe_L">{{ $t('label.Gift_card_remission') }}:</div>
          <div class="zonghe_R">
            -{{$t('currency.symbol')}}{{ Number(list.cardAmount).toFixed(2) }}
          </div>
        </div>
        <div class="zonghe">
          <div v-if="list.orderStatus == 0" class="zonghe_L red">{{ $t('label.Account_payable') }}:</div>
          <div v-else class="zonghe_L red">{{$t('label.Actual_payment')}}:</div>
          <div class="zonghe_R red1">
            {{$t('currency.symbol')}}{{ Number(list.orderAmount).toFixed(2) }}
          </div>
        </div>
      </div>
    </div>
    <Foot />
  </div>
</template>
<script>
import { post, get } from '@/utils/request';
import Header from '@/components/header.vue';
import Foot from '@/components/foot.vue';
import Search from '@/components/order/search.vue';
import { confirmOrder } from '@/utils/pageUtils.js';
import { submitOrderTemp } from '@/api/order.js';
export default {
  components: {
    Header,
    Foot,
    Search,
  },
  data() {
    return {
      tableData: [],
      FillingList:[{
        certificateNo:'',
      }],
      Remark:'',
      FillingList2:null,
      msg:'',
      list: [],
      cylinderList:[],
      jifen: '0',
      erpContractMsg:'',
      erpContract:{
        contractCode:'',
      }
    };
  },
  created() {
    this.getdetail(this.$route.query.orderId);
    this.orderToErpDetail(this.$route.query.orderId);
    this.orderToErpContract(this.$route.query.orderId);
  },
  methods: {
    // getdetail(e, t) {
    //   get('api/sku/getskuitem?skuId=' + e + '&orderId=' + t + '').then(
    //     (res) => {
    //       this.list = res.data.data;
    //       this.isLoading = false;
    //     }
    //   );
    // },
    formatDate(row, column, cellValue, index) {
    // 例如，将日期格式化为 yyyy-MM-dd HH:mm:ss
    if (!cellValue) return '';
      return new Date(cellValue).toLocaleString(); 
  },
    buy(e) {
      let orderTemp = [];
      orderTemp.push({
        skuId: e.skuId,
        num: e.skuCount,
        value: e.contentValue,
        storeId: e.storeId,
      });
      submitOrderTemp(orderTemp).then((res) => {
        confirmOrder();
      });
    },
    tuikuan(e) {
      this.$router.push({
        name: 'Tuihuosq',
        params: {
          skuId: e.skuId,
          orderId: e.orderId,
        },
      });
    },
    // ERP充装信息
    orderToErpDetail(e){
      get('api/syncData/orderToErpDetail?orderId=' + e + '').then((res) => {
        this.msg = res.data.data.msg;
        this.FillingList = res.data.data.data;
        if(this.msg=='未充装'){
          if(this.FillingList.remark =='1'){
            this.Remark = this.$t('message.Order_making_completed');
          }else if(this.FillingList.remark =='2'){
            this.Remark = this.$t('message.Contract_generation');
          } else if(this.FillingList.remark =='3'){
            this.Remark = this.$t('message.Contract_to_production');
          }
        }
      });
    },
    // ERP合同信息
    orderToErpContract(e){
      get('api/syncData/orderToErpContract?orderId=' + e + '').then((res) => {  
        if(res.data.data){
          this.erpContractMsg = res.data.data.msg;
          this.erpContract = res.data.data.data;
        }
      });
    },
    // 订单详情
    getdetail(e) {
      get('api/orderbasic/getorderbyid?orderId=' + e + '').then((res) => {
          this.list = res.data.data;
          this.tableData = res.data.data.orderSkuVoList;
          this.cylinderList = res.data.data.cylinderList;
        res.data.data.orderSkuVoList.forEach((req) => {
          if(req.contentValue != null){
            req.contentValue = eval('(' + req.contentValue + ')');
          }else{
            req.contentValue = eval('([])');
          }
          if (req.value != '0mol/mol' && req.value != '0ppm' && req.value != null) {
              if (req.value.indexOf('mol/mol') != -1) {
                req.contentValue.push({
                  attrName: this.$t('common.Confirmed_content'),
                  attrValue: req.value.replace(
                    'mol/mol',
                    'X10<sup>-6</sup>mol/mol'
                  ),
                });
              } else {
                req.contentValue.push({
                  attrName: this.$t('common.Confirmed_content'),
                  attrValue: req.value,
                });
              }
            }
          req.contentValue.forEach((k, index) => {
            if (k.attrName == '浓度范围'||k.attrName == 'Concentration Range') {
              req.contentValue.splice(index, 1);
            }
          });
          req.skuPrice = Number(req.skuPrice).toFixed(2);
          this.jifen += req.useScore;
        });
        for (let q = 0; q < res.data.data.orderSkuVoList.length; q++) {
            for (let j = q + 1; j < res.data.data.orderSkuVoList.length; j++) {
              if(res.data.data.orderSkuVoList[q].remark =='1'&& res.data.data.orderSkuVoList[j].remark=='1'){
                if (res.data.data.orderSkuVoList[q].prodCatId == res.data.data.orderSkuVoList[j].prodCatId&&res.data.data.orderSkuVoList[q].spuName == res.data.data.orderSkuVoList[j].spuName&&res.data.data.orderSkuVoList[q].storeId == res.data.data.orderSkuVoList[j].storeId&&res.data.data.orderSkuVoList[q].batchNumber == res.data.data.orderSkuVoList[j].batchNumber) {
                  for (
                    let p = 0;
                    p < res.data.data.orderSkuVoList[j].contentValue.length;
                    p++
                  ) {
                    if (
                      res.data.data.orderSkuVoList[j].contentValue[p].attrName == '多组分' ||
                      res.data.data.orderSkuVoList[j].contentValue[p].attrName == 'Multicomponent' ||
                      res.data.data.orderSkuVoList[j].contentValue[p].attrName == '气体组分' ||
                      res.data.data.orderSkuVoList[j].contentValue[p].attrName == 'Gas Components' ||
                      res.data.data.orderSkuVoList[j].contentValue[p].attrName == '确认含量' ||
                      res.data.data.orderSkuVoList[j].contentValue[p].attrName == 'Confirmed content'
                    ) {
                      res.data.data.orderSkuVoList[q].contentValue.push(
                        res.data.data.orderSkuVoList[j].contentValue[p]
                      );
                    }
                  }
                }
              }
            }
          }
          for (let q = 0; q < res.data.data.orderSkuVoList.length; q++) {
            for (let j = q+1; j < res.data.data.orderSkuVoList.length; j++) {
              if(res.data.data.orderSkuVoList[q].remark =='1'&& res.data.data.orderSkuVoList[j].remark=='1'){
                if (res.data.data.orderSkuVoList[q].prodCatId == res.data.data.orderSkuVoList[j].prodCatId&&res.data.data.orderSkuVoList[q].spuName == res.data.data.orderSkuVoList[j].spuName&&res.data.data.orderSkuVoList[q].storeId == res.data.data.orderSkuVoList[j].storeId&&res.data.data.orderSkuVoList[q].batchNumber == res.data.data.orderSkuVoList[j].batchNumber) {
                  res.data.data.orderSkuVoList.splice(j,1);
              }
            }
            }
          }
          for (let q = 0; q < res.data.data.orderSkuVoList.length; q++) {
            for (let j = q+1; j < res.data.data.orderSkuVoList.length; j++) {
              if(res.data.data.orderSkuVoList[q].remark =='1'&& res.data.data.orderSkuVoList[j].remark=='1'){
                if (res.data.data.orderSkuVoList[q].prodCatId == res.data.data.orderSkuVoList[j].prodCatId&&res.data.data.orderSkuVoList[q].spuName == res.data.data.orderSkuVoList[j].spuName&&res.data.data.orderSkuVoList[q].storeId == res.data.data.orderSkuVoList[j].storeId&&res.data.data.orderSkuVoList[q].batchNumber == res.data.data.orderSkuVoList[j].batchNumber) {
                  res.data.data.orderSkuVoList.splice(j,1);
              }
            }
            }
          }
          for (let q = 0; q < res.data.data.orderSkuVoList.length; q++) {
            for (let j = q+1; j < res.data.data.orderSkuVoList.length; j++) {
              if(res.data.data.orderSkuVoList[q].remark =='1'&& res.data.data.orderSkuVoList[j].remark=='1'){
                if (res.data.data.orderSkuVoList[q].prodCatId == res.data.data.orderSkuVoList[j].prodCatId&&res.data.data.orderSkuVoList[q].spuName == res.data.data.orderSkuVoList[j].spuName&&res.data.data.orderSkuVoList[q].storeId == res.data.data.orderSkuVoList[j].storeId&&res.data.data.orderSkuVoList[q].batchNumber == res.data.data.orderSkuVoList[j].batchNumber) {
                  res.data.data.orderSkuVoList.splice(j,1);
              }
            }
            }
          }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.title {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.content {
  background: #f5f5f5;
}
.breadcrumb {
  width: 1180px;
  margin: 0 auto;
  height: 43px;
  padding: 20px 0 10px 0;
}
.status {
  width: 1235px;
  height: 306px;
  border-top: 4px solid #ff9f48;
  margin: 0 auto;
  background: #fff;
  display: flex;

  .jieshao {
    width: 314px;
    height: 100%;
    padding: 30px 0 0 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-right: 1px solid #f4f4f4;
    .jie_L {
      width: 96px;
      height: 96px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .jie_R {
      height: 96px;
      font-size: 12px;
      transform: scale(1);
      color: #7a7a7a;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      margin-top: 20px;
    }
  }
  .status_R {
    padding: 25px 0 28px 25px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .shang {
      font-size: 14px;
      color: #989898;
    }
    .zhong {
      margin-left: -10px;
      display: flex;
      align-items: flex-start;
      .zt {
        margin-top: 20px;
      }
      .time {
        font-size: 12px;
        color: #828282;
        margin-top: 10px;
        padding-left: 10px;
        width: 140px;
      }
      .dingdan {
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 40px;
          height: 40px;
        }
      }
      .jiantou {
        margin-left: -10px;
        display: flex;
        align-items: flex-end;
        height: 30px;
        img {
          width: 40px;
          margin: 0 20px;
        }
      }
      .fukuan {
        margin-left: -20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 40px;
          height: 40px;
        }
      }
      .shangpin {
        margin-left: -20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 40px;
          height: 40px;
        }
      }
      .shouhuo {
        margin-left: -20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 45px;
          height: 40px;
        }
      }
      .wancheng {
        margin-left: -20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 39px;
          height: 39px;
        }
      }
    }
    .xia {
      font-size: 12px;
      color: #767676;
      img {
        width: 23px;
        height: 15px;
        margin-right: 15px;
      }
      .num {
        color: #f60d06;
        margin-left: 10px;
      }
    }
  }
}
.wuliu {
  width: 1235px;
  height: 318px;
  background: #fff;
  margin: 0 auto;
  margin-top: 23px;
  display: flex;
  .jieshao {
    width: 314px;
    height: 100%;
    padding: 30px 0 0 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-right: 1px solid #f4f4f4;
    .jie_L {
      width: 96px;
      height: 96px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .jie_R {
      height: 96px;
      font-size: 12px;
      transform: scale(1);
      color: #7a7a7a;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      margin-top: 20px;
    }
  }
}
.fahuo_detail{
  // height: 230px;
  width: 100%;
  background: #fff;
  margin: 20px auto;
  padding-bottom: 10px;
  display: flex;
  .xinxi {
    width: 100%;
    height: 100%;
    padding-left: 38px;
    padding-right: 40px;
    font-size: 12px;
    color: #3f3f3f;
    .spen {
      height: 63px;
      line-height: 73px;
      font-weight: 600;
      font-size: 16px;
      color: #292929;
    }
     .xinxi1 {
      display: flex;
      margin-top: 10px;
      .xinxi1_L {
        width: 100px;
      }
    }
  }
}
.shouhuo_detail {
  height: 265px;
  width: 100%;
  background: #fff;
  margin: 20px auto;
  display: flex;
  .xinxi {
    width: 45%;
    height: 100%;
    border-right: 1px solid #f3f3f3;
    padding-left: 38px;
    font-size: 12px;
    color: #3f3f3f;
    .spen {
      height: 63px;
      line-height: 73px;
      font-weight: 600;
      font-size: 16px;
      color: #292929;
    }
    .xinxi1 {
      display: flex;
      margin-top: 10px;
      .xinxi1_L {
        width: 100px;
      }
      .xinxi1_R {
        width: 300px;
      }
    }
  }
  // .peisong {
  //   border-right: 1px solid #f3f3f3;
  //   width: 400px;
  //   height: 100%;
  //   padding-left: 28px;
  //   font-size: 12px;
  //   color: #3f3f3f;
  //   .spen {
  //     height: 63px;
  //     line-height: 73px;
  //     font-weight: 600;
  //     font-size: 16px;
  //     color: #292929;
  //   }
  //   .xinxi1 {
  //     display: flex;
  //     margin-top: 10px;
  //     .xinxi1_L {
  //       width: 150px;
  //     }
  //     .xinxi1_R {
  //       width: 300px;
  //     }
  //   }
  // }
  .fukuan {
    padding-left: 130px;
    font-size: 12px;
    color: #3f3f3f;
    .spen {
      height: 63px;
      line-height: 73px;
      font-weight: 600;
      font-size: 16px;
      color: #292929;
    }
    .xinxi1 {
      display: flex;
      margin-top: 10px;
      .xinxi1_L {
        width: 100px;
      }
    }
  }
}
.biaoge {
  width: 1182px;
  background: #fff;
  margin: 20px auto;
  padding: 28px 27px;
  .zonghe {
    width: 100%;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    color: #333;
    margin-top: 15px;
    .zonghe_L {
      width: 1060px;
      display: flex;
      justify-content: flex-end;
    }
    .red {
      color: #e33638;
    }
    .red1 {
      color: #e33638;
      font-size: 14px;
    }
  }
  .zufen {
    margin-left: 5px;
    font-size: 12px;
    display: flex;
  }
  .xinghao {
    color: #999;
  }
}
</style>
